import type { InterruptVesselCallByIdArgs } from "@services/vesselCall/types";
import { interruptVesselCallById } from "@services/vesselCallApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useInterruptVesselCall = ({
  handleSuccess,
}: {
  handleSuccess: (status?: string) => void;
}) => {
  const interruptCallMutation = useMutation({
    mutationFn: (variables: Parameters<typeof interruptVesselCallById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "VesselCallStatus",
          action: "interrupt_vessel_call",
          entityType: "vessel_call",
        },
        (transactionId) =>
          interruptVesselCallById({
            ...variables,
            ...(transactionId ? { transactionId } : {}),
          }),
      ),
    onSuccess: async (_data, variables) => {
      const status = variables?.params?.isVesselForcedToLeavePort
        ? "INTERRUPTED_LEAVE_PORT"
        : "INTERRUPTED_IN_PORT";
      handleSuccess(status);
    },
  });

  const interruptCall = async ({
    service,
    vesselCallId,
    params,
  }: {
    service: string;
    vesselCallId: string;
    params: InterruptVesselCallByIdArgs;
  }) => {
    await interruptCallMutation.mutateAsync({
      service,
      vesselCallId,
      params,
    });
  };

  return {
    interruptCall,
  };
};
